import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import monsterActions from '../actions/monster'

export const useMonster = () => {
  const data = useSelector((state) => {
    return get(state, 'app.monsterManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(monsterActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
